(() => {
  if(window.__adultsuperKeitaroAttribution)return;
  window.__adultsuperKeitaroAttribution=true;
  const script=document.querySelector('script[data-keitaro-days]');
  const days=Math.max(1,Math.min(90,Number(script?.dataset.keitaroDays)||30));
  const configuredCode=script?.dataset.keitaroDiscountCode||'';
  const discountCode=/^AS-KT-[A-F0-9]{24}$/.test(configuredCode)?configuredCode:'';
  const discountEnabled=script?.dataset.keitaroDiscountEnabled==='true';
  const key='as_keitaro_click_v1';
  const valid=s=>typeof s==='string'&&/^[A-Za-z0-9._~-]{1,128}$/.test(s);
  let running=Promise.resolve();
  async function sync(){
    const privacy=window.Shopify?.customerPrivacy;
    if(!privacy)return;
    const allowed=privacy.analyticsProcessingAllowed()&&privacy.marketingAllowed();
    let old=null;
    try{old=JSON.parse(localStorage.getItem(key)||'null');}catch{}
    const now=Date.now(),incoming=new URLSearchParams(location.search).get('subid');
    let click=old&&valid(old.subid)&&old.capturedAt<=now+60000&&old.capturedAt>=now-days*86400000&&old.expiresAt>now?old:null;
    if(allowed&&valid(incoming)&&incoming!==click?.subid)click={subid:incoming,capturedAt:now,expiresAt:now+days*86400000};
    if(!allowed)click=null;
    try{if(click)localStorage.setItem(key,JSON.stringify(click));else localStorage.removeItem(key);}catch{}
    document.cookie=click?`${key}=${encodeURIComponent(JSON.stringify(click))}; path=/; max-age=${Math.floor((click.expiresAt-now)/1000)}; SameSite=Lax; Secure`:`${key}=; path=/; max-age=0; SameSite=Lax; Secure`;
    if(!click&&!old&&!discountCode)return;
    const root=window.Shopify?.routes?.root||'/';
    const res=await fetch(`${root}cart.js`,{credentials:'same-origin'});
    if(!res.ok)return;
    const cart=await res.json(),attrs=cart.attributes||{};
    const subid=click?.subid||'',at=click?String(click.capturedAt):'';
    const body={};
    if((attrs.keitaro_subid||'')!==subid||(attrs.keitaro_captured_at||'')!==at)body.attributes={keitaro_subid:subid,keitaro_captured_at:at};
    const codes=(cart.discount_codes||[]).map(d=>d.code).filter(c=>typeof c==='string');
    const hasManaged=discountCode&&codes.some(c=>c.toUpperCase()===discountCode);
    const wantManaged=Boolean(discountEnabled&&discountCode&&click);
    if(wantManaged&&!hasManaged)body.discount=[...codes,discountCode].join(',');
    else if(!wantManaged&&hasManaged)body.discount=codes.filter(c=>c.toUpperCase()!==discountCode).join(',');
    if(!Object.keys(body).length)return;
    const update=await fetch(`${root}cart/update.js`,{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    if(update.ok&&body.discount!==undefined){
      const updated=await update.json();
      document.dispatchEvent(new CustomEvent('keitaro:discount-updated',{detail:{cart:updated}}));
      if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'adultsuper-keitaro',cartData:updated}).catch(()=>{});
    }
  }
  const schedule=()=>{running=running.then(sync).catch(()=>{});};
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event?.source!=='adultsuper-keitaro')schedule();});
  document.addEventListener('visitorConsentCollected',schedule);
  window.addEventListener('pageshow',schedule);
  if(window.Shopify?.customerPrivacy)schedule();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)schedule();});
})();
